import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDown, faAngleRight, faLock, faPlus, faTrashAlt, faUnlock,
} from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Text } from '@domain-group/suit-theme'

import type { ProviderPriceListModel } from '@models/types'

import PageContext from '@contexts/pageContext'

import { confirmDelete, formatEntityCount } from '@functions/entity'

import usePriceListProduct from '../../../../hooks/usePriceListProduct'

import PriceListItem from './PriceListItem'

interface ProductProps {
  callbacks: {
    deleteItemsForProduct: VoidFunction,
    showCreateOrEditProviderPriceListItemModal: VoidFunction,
  },
  isMaster: boolean,
  last: boolean,
  providerPriceList: ProviderPriceListModel,
  serviceProductId: number,
}

const Product = (props: ProductProps) => {
  const {
    callbacks: {
      deleteItemsForProduct,
      showCreateOrEditProviderPriceListItemModal,
    },
    isMaster,
    last = false,
    providerPriceList,
    serviceProductId,
  } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      selectPriceListItemId,
    },
    selectedPriceListItem,
  } = pageContext

  const priceListProductPayload = usePriceListProduct({ isMaster, providerPriceList, serviceProductId })
  const {
    callbacks: {
      toggleOpen,
    },
    filteredProviderPriceListItems,
    isLocked,
    isOpen,
    serviceProduct,
    visiblePriceListItems,
  } = priceListProductPayload

  const confirmDeletePayload = {
    callbacks: {
      deleteFn: deleteItemsForProduct,
    },
    strings: {
      confirmString: 'Are you sure? All items and their options will be deleted.',
      entityName: 'Price List Items',
    },
  }

  return (
    <Box
      borderBottom={last ? 'none' : '1px dashed'}
      borderColor="lineColor"
      // @ts-expect-error
      disableHover
      flexDirection="column"
      fontSize="small"
      padding="large"
    >
      <Box onClick={() => toggleOpen()} style={{ cursor: 'pointer' }}>
        <Box alignItems="center" color={isLocked ? 'red' : 'green'} justifyContent="center" width={14}>
          <FontAwesomeIcon icon={isLocked ? faLock : faUnlock} />
        </Box>

        <Box flexDirection="column" marginLeft="large">
          <Text color="bodyFontColor">
            {/* @ts-expect-error */}
            {serviceProduct.title}
          </Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            {/* @ts-expect-error */}
            #{serviceProduct.id}
          </Text>
        </Box>

        <Box justifyContent="flex-end" marginRight="large">
          <Text color="bodyFontLightColor" fontSize="xsmall" marginLeft="medium" marginTop="auto" marginBottom="auto">
            {formatEntityCount({ entityString: 'Item', entityCount: visiblePriceListItems.length })}
          </Text>
        </Box>

        <Box alignItems="center" marginLeft="auto" width="auto">
          <FontAwesomeIcon icon={isOpen ? faAngleDown : faAngleRight} />
        </Box>
      </Box>

      {isOpen && (
        <>
          <Box flexDirection="column" marginTop="large">
            {filteredProviderPriceListItems.map((priceListItem, index) => (
              <PriceListItem
                callbacks={{
                  selectPriceListItem: () => selectPriceListItemId(priceListItem.id),
                }}
                hidden={!visiblePriceListItems.find(item => item.id === priceListItem.id)}
                isMaster={isMaster}
                key={priceListItem.id}
                last={index + 1 === filteredProviderPriceListItems.length}
                providerPriceListItem={priceListItem}
                selected={selectedPriceListItem.id === priceListItem.id}
              />
            ))}
          </Box>

          {isMaster && (
            <Box flexDirection="column" marginTop="large">
              <Button
                buttonStyle="secondaryEdit"
                icon={<FontAwesomeIcon icon={faPlus} />}
                onClick={showCreateOrEditProviderPriceListItemModal}
                size="small"
              >
                Add Quantity
              </Button>

              <Button
                buttonStyle="secondaryDestroy"
                icon={<FontAwesomeIcon icon={faTrashAlt} />}
                // @ts-expect-error TS2345
                onClick={() => confirmDelete(confirmDeletePayload)}
                marginTop="small"
                size="small"
              >
                Delete Product
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  )
}

export default Product
